module.exports = __webpack_public_path__ + "static/media/svg-13.99354c0e.svg";